export default function getDataserviceUrl(env: string) {
  switch (env) {
    case 'dev':
      return 'https://dataservice.gamma.dev.us-west-2.aws.avalara.io';
    case 'local':
    case 'ci':
    case 'qa':
    case 'uat':
      return 'https://dataservice.gamma.qa.us-west-2.aws.avalara.io';
    case 'sbx':
      return 'https://sandbox.data.webplatform.avalara.com';
    case 'prod':
    default:
      return 'https://data.webplatform.avalara.com';
  }
}
